module.exports = __webpack_public_path__ + "static/media/04.ed3e1603.jpg";